import DeleteTemplateCategory from '@/connection/categories/delete-template-category';
import { TemplatesReducerCreator } from '../types';

const deleteTemplateCategoryReducer = (create: TemplatesReducerCreator) => {
  return create.asyncThunk(
    async ({ categoryUuid }: { categoryUuid: string }) => {
      await DeleteTemplateCategory({ categoryUuid });
      return categoryUuid;
    },
    {
      fulfilled: (state, action) => {
        const removedUuid = action.payload;
        state.categoryFilters = (state.categoryFilters || []).filter((category) => category.uuid !== removedUuid);
      },
      rejected: (state, action) => {
        console.error(action.error);
      },
    }
  );
};

export default deleteTemplateCategoryReducer;
